import { Content, OutputMediaContent } from "@/types";

export const isOutputMediaContent = (content: Content): content is OutputMediaContent =>
  content.type === "output_media" && "url" in content && Boolean(content.url);

export const collectConsecutiveOutputMedia = (contents: Content[], startIndex: number) => {
  const group: OutputMediaContent[] = [];
  for (let index = startIndex; index < contents.length; index += 1) {
    const content = contents[index];
    if (!isOutputMediaContent(content)) {
      break;
    }
    group.push(content);
  }
  return group;
};

export const hasFullscreenMediaContent = (contents: Content[]) =>
  contents.some(content => content.type === "output_media" || content.type === "media");
